import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '../assets/icons';

export interface Crumb {
  label: string;
  to?: string;
}

/** Shared page breadcrumb trail. Last item renders as the current (bold) page. */
export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-sm">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${c.label}-${i}`} className="flex items-center gap-2">
            {c.to && !last ? (
              <Link
                to={c.to}
                className="cursor-pointer font-medium text-ink-secondary no-underline transition-colors hover:text-brand hover:underline"
              >
                {c.label}
              </Link>
            ) : (
              <span className={last ? 'font-semibold text-ink' : 'font-medium text-ink-secondary'}>
                {c.label}
              </span>
            )}
            {!last && <ChevronRightIcon className="h-[9px] w-[5.55px] shrink-0 text-ink-secondary" />}
          </span>
        );
      })}
    </nav>
  );
}
